import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAvailableJobs } from "../../redux/employerJob/employerJobSlice"; // Adjust path as needed
import { Link } from "react-router-dom";

function EmployerJobAvailabilityView() {
  const dispatch = useDispatch();
  const { employerJobList, loading, error } = useSelector((state) => state.EmployerListedJob);
  const { currentUser } = useSelector((state) => state.user); // Still used for userType check

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (userId ) {
      dispatch(fetchAvailableJobs(userId));
    }
  }, [dispatch, currentUser]);

  if (loading) return <div className="p-4">Loading...</div>;
  if (error) return <div className="p-4 text-red-500">Error: {error.message}</div>;

  const availableJobs = employerJobList.filter((job) => job.availableJobseekers > 0);

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Available Jobs with Jobseekers</h2>
      {availableJobs.length > 0 ? (
        <ul className="space-y-4">
          {availableJobs.map((job) => (
            <li key={job._id} className="border p-4 rounded shadow">
              <h3 className="font-semibold">{job.jobTitle}</h3>
              <p>Location: {job.state}, {job.localGovernment}</p>
              <p>Available Jobseekers: {job.availableJobseekers || 0}</p>
              <Link
                to={`/employer/job/${job._id}/details`}
                className="mt-2 inline-block px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
              >
                View Details
              </Link>
            </li>
          ))}
        </ul>
      ) : (
        <p>No available jobs with jobseekers.</p>
      )}
    </div>
  );
}

export default EmployerJobAvailabilityView;